import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import {FormInlineRowComponent} from './../forms/form-inline-row';
import {MessageComponent, BaseComponent} from '../common/common-components';
import {DictionaryService} from "../services/dictionary-service";
import {MessageService} from "../services/message-service";
import {WalletService} from "./wallet-service";
import {ViewportService} from "../services/viewport-service";

declare var BACKENDPATH: any;

let _ : any = require("lodash");

@Component({
    selector: 'dk-wallet-transactions',
    template: require('./wallet-transactions.html'),
    entryComponents: [],
    providers: [DictionaryService, WalletService]
})

export class WalletTransactionsComponent extends BaseComponent implements OnInit {
    transactions: any[];
    searchForm: WalletTransactionSearchForm;
    showForm: boolean = true;

    constructor (private walletService: WalletService, viewportService: ViewportService) {
        super();
        this.showForm = !viewportService.sizeSm();
        this.searchForm = new WalletTransactionSearchForm();
        this.searchForm.searchDateFrom = null;
        this.searchForm.searchDateTo = null;
        this.searchForm.searchRecharge = false;
        this.searchForm.searchWithdrawal = false;
        this.searchForm.searchExchange = false;
        this.searchForm.searchStatusWaiting = false;
        this.searchForm.searchStatusCommit = false;
        this.searchForm.searchStatusCancel = false;
        this.searchForm.searchTransactionId = null;
    }

    public ngOnInit() {
        this.load();
    }

    load() {
        this.walletService.transactions(this.searchForm).subscribe(transactions => {
            this.transactions = transactions;
        });
    }

    showDetails(transaction) {
        transaction.ShowDetails = transaction.ShowDetails ? false : true;
    }

    getBillUrl(transaction) {
        return BACKENDPATH + '/api/wallet/get-bill?id=' + transaction.TransactionID;
    }

    switchForm() {
        this.showForm = !this.showForm;
    }
}

class WalletTransactionSearchForm
{
    searchDateFrom: Date;
    searchDateTo: Date;
    searchRecharge: boolean;
    searchWithdrawal: boolean;
    searchExchange: boolean;
    searchStatusWaiting: boolean;
    searchStatusCommit: boolean;
    searchStatusCancel: boolean;
    searchTransactionId: number;
}

